export class Renderer {

    initRenderer (node, tree) {
        node.__logicalTree = tree;
    }
}
